/** 창 단위 화면 이동 — 메뉴마다 고정 창 이름을 붙여, 열려 있으면 그 창으로 이동(작업 보존)하고
 *  없으면 새 창을 연다. 회사관리 탭(회사·일일매출·구매장·라벨·분석)과 회사별 /main 창이 같은 규칙.
 *
 *  회사 선택·'회사 변경'이 지금 창을 다른 화면으로 바꾸면, 그 창 이름과 내용이 어긋나 '회사 선택' 창이
 *  둘이 되던 문제가 있었다(2026-11-04) — 그래서 이동도 창을 바꾸지 않고 해당 창으로 보낸다. */

export const ADMIN_TABS = ['회사', '일일매출', '구매장', '라벨', '분석'] as const
export type AdminTab = typeof ADMIN_TABS[number]

export const adminWindowName = (t: AdminTab) => `gf-admin-${ADMIN_TABS.indexOf(t)}`
export const adminUrl = (t: AdminTab) =>
  (t === '회사' ? '/company-select' : `/company-select?tab=${encodeURIComponent(t)}`)

/** 경로별 /main 창 이름(MainShell 과 같은 규칙). */
export const mainWindowName = (cid: number | string, path: string) => `gf-tab-${cid}-${path.replace(/\W+/g, '_')}`

/** 이름 붙은 창으로 이동. 팝업이 막히면 false(호출한 쪽이 지금 창에서 이동). */
export function focusWindow(name: string, url: string): boolean {
  if (window.name === name) return true
  const win = window.open('', name)
  if (!win) return false
  if (win.location.href === 'about:blank') win.location.href = url
  win.focus()
  return true
}
